<p-toast position="top-right"></p-toast>
<div class="p-g">
    <div class="p-g-12">
        <div class="card card-w-title trainerAttendanceMarking">

            <p-dialog style="font-weight: 600;" [modal]="true" [header]='setLabel("trainingSessionsHeaderLabel")'
                (onHide)="hideModal()" [(visible)]="trainingSessionsDialog" class="dialogPop">
                <form class="payout-main-wrapper" #TrainingSessionsDialogForm="ngForm"
                    style="width: 320px; text-align: inherit;">
                    <div *ngIf="allowReschedule" class="payout-fields payout-field-checkbox">
                        <p-checkbox [label]='setLabel("rescheduleLabel")' [(ngModel)]="reschedule" [binary]="true" name="reschedule"></p-checkbox>
                    </div>
                    <div *ngIf="!reschedule || !allowReschedule">
                        <div class="payout-fields">
                            <span class="label">{{setLabel("memberNameLabel")}}</span>
                            <span class="bind">{{ memberName }}</span>
                        </div>
                        <span class="p-g-12"></span>

                        <div class="payout-fields">
                            <span class="label">{{setLabel("trainerLabel")}}</span>
                            <span class="bind"> {{ trainerName}}</span>
                        </div>
                        <span class="p-g-12"></span>
                        <div class="payout-fields">
                            <span class="label">{{setLabel("statusLabel")}}</span>
                            <span class="bind">{{ status}}</span>
                        </div>
                        <span class="p-g-12"></span>
                        <div class="payout-fields ">
                            <span class="label">{{setLabel("performanceLabel")}} </span>
                            <p-dropdown [options]="memberPerformanceArray" pInputText placeholder='Select'
                                appendTo="body" name="memberPerformance" optionLabel="name1" optionValue="code1"
                                [disabled]="!allowAttendance"
                                [(ngModel)]="memberPerformance" #name="ngModel">
                            </p-dropdown>
                        </div>
                        <span class="p-g-12"></span>

                        <div class="payout-fields">
                            <span class="label">{{setLabel("excersiseTypeLabel")}} </span>
                            <p-multiSelect pInputText [placeholder]='setLabel("selectPlaceholderLabel")' appendTo="body"
                                [options]="excerciseOptions" [(ngModel)]="selectedexcerciseOptions" optionLabel="name2"
                                [disabled]="!allowAttendance"
                                optionValue="code2" name="selectedexcerciseOptions"></p-multiSelect>
                        </div>
                        <div *ngIf="allowAttendance" class="p-g-12" style="margin-top: 20px;display: flex;gap: 20px">
                            <button class="p-g-6" type="button" pButton (click)="markPresent()"
                                [label]='setLabel("presentLabel")'
                                style="margin-right: 10px; background-color: #4CAF50;"></button>
                            <button class="p-g-6" type="button" pButton (click)="markAbsent()"
                                [label]='setLabel("absentLabel")' style="background-color: #F44336;"></button>
                        </div>
                    </div>
                    <div class="payout-fields" *ngIf="allowReschedule && reschedule" style="display: flex; ">
                        <span class="label">{{setLabel("selectDateLabel")}} </span>
                        <p-calendar [yearNavigator]="true" appendTo="body" yearRange="1950:2040" [monthNavigator]="true"
                            [minDate]="minDate" [(ngModel)]="selectedDate" [placeholder]='setLabel("rescheduleDatePlaceholderLabel")'
                            name="createdDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
                        </p-calendar>
                    </div>
                    <div ngClass="payout-fields" *ngIf="allowReschedule && reschedule" class="p-g-12"
                        style="margin-top: 20px; display: flex;justify-content: center;">
                        <button type="button" pButton (click)="rescheduleSession()"
                            [label]='setLabel("rescheduleLabel")'
                            style="margin-right: 10px; background-color: rgb(80, 120, 252);"></button>
                    </div>
                </form>
            </p-dialog>

            <p-dialog style="font-weight: 600;" header="Class Training" (onHide)="hideModal()" [(visible)]="classSessionsDialog"
                class="dialogPop">
                <form class="payout-main-wrapper" #TrainingSessionsDialogForm="ngForm" style="width: 320px; text-align: inherit;">
                    <div *ngIf="allowReschedule" class="payout-fields payout-field-checkbox">
                        <p-checkbox [label]='setLabel("rescheduleLabel")' [(ngModel)]="reschedule" [binary]="true"
                            name="reschedule"></p-checkbox>
                    </div>
                    <div  style="display: flex; flex-direction: column; gap: 1rem;" *ngIf="!reschedule || !allowReschedule">
                        <div class="payout-fields" *ngFor="let member of members">

                            <div style="display: flex; gap: 1em;">
                                <span class="bind">{{member.name}}</span>
                                <input type="checkbox" style="width: auto;" [checked]="member.attendedStatus === 'ATTENDED'"
                                    [disabled]="!allowAttendance"
                                    (change)="changeAttendedStatus(member)">
                            </div>
                        </div>
                        <div *ngIf="allowAttendance" style="margin-top:1rem; display: flex;justify-content: center;">
                            <button type="button" pButton (click)="markClassAttendance()" label="Mark Class Attendance"
                                style="margin-right: 10px; background-color: rgb(80, 120, 252);"></button>
                        </div>
                    </div>
                    <div *ngIf="allowReschedule && reschedule">
                        <div class="payout-fields" style="display: flex; ">
                            <span class="label">{{setLabel("selectDateLabel")}} </span>
                            <p-calendar [yearNavigator]="true" appendTo="body" yearRange="1950:2040" [monthNavigator]="true"
                                [minDate]="minDate" [(ngModel)]="selectedDate" [placeholder]='setLabel("rescheduleDatePlaceholderLabel")'
                                name="createdDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
                            </p-calendar>
                        </div>
                        <div ngClass="payout-fields" class="p-g-12"
                            style="margin-top: 20px; display: flex;justify-content: center;">
                            <button type="button" pButton (click)="rescheduleClassSession()" [label]='setLabel("rescheduleLabel")'
                                style="margin-right: 10px; background-color: rgb(80, 120, 252);"></button>
                        </div>
                    </div>
                </form>
            </p-dialog>
            <p-panel [header]='setLabel("trainingSessionsHeaderLabel")'
                [style]="{ height: '100%', 'margin-top': '4px' }" class="calenderHeader">
                <full-calendar [events]="events" [options]="scheduleOptions"></full-calendar>
            </p-panel>
        </div>
    </div>
</div>